module.exports = __webpack_public_path__ + "static/media/retrato-gris.1b9ebad7.svg";